import React, { useState, useEffect } from 'react';
import { API_URL, secret_key, storedData } from '../Constants';
import axios from 'axios';
import Swal from "sweetalert2";
import Select from 'react-select';
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import loading1 from "../../assets/loading.gif"

function NewMessage() {
  const [smsdata, setsmsData] = useState({
    subject: "",
    message_body: "",
    sms_groups: [],
    group_id: []
  });

  const [contactgroups, setContactgroups] = useState([]);
  const [groupError, setGroupError] = useState("");
  const [subjError, setsubjError] = useState("");
  const [bodyError, setbodyError] = useState("");

  let navigate = useNavigate();

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;
if (storedData) {
  var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
  var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}
  const [companydata, setcompanydata] = useState("");

  //Get company by id
  const fetchCompanyByID = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${API_URL}/get_company/${logeduserData?.company_id}`,
      headers: { 
        'Authorization': token
      }
    };
    
    axios.request(config)
    .then((response) => {
      setcompanydata(response.data)
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        navigate(0);
      }
    });
  };

  useEffect(() => {
    fetchCompanyByID();
  }, []);


  // Set form values on change
  const handleChange = (e) => {
    const { id, value } = e.target;
    setsmsData((prevState) => ({
      ...prevState,
      [id]: value
    }));
  };

  // Send bulk SMS
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sendSMS = (e) => {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    //set errors
    if (smsdata.group_id.length === 0) {
      setGroupError("Please select at least one group"); 
      return;
    }
    if (smsdata.subject === "") {
      setsubjError("Message subject is required"); 
      return;
    }

    if (smsdata.message_body === "") {
      setbodyError("Message body is required"); 
      return;
    }

    let formData = {
      "message_subject": smsdata.subject,
      "message_body": smsdata.message_body,
      "group_id": smsdata.group_id.map((group) => group.value).join(","),
      "sms_groups": smsdata.group_id.map((group) => group.label).join(","),
      "rate": companydata.rate,
      "company_id": logeduserData?.company_id,
    };

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/postMessageHeader`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data: formData
    };

    axios.request(config)
      .then((response) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Message saved",
        });
        navigate(`/prev_message/${response.data.id}?sms_status=${encodeURIComponent(0)}`);
      })
      .catch((error) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data,
        })
      });
  };
  

  const handleDiscard = () => {
    setsmsData({
      subject: "",
      message_body: "",
      group_id: [],
      sms_groups: []
    });
  };

  const removeError = () => {
    setGroupError("");
    setsubjError("");
    setbodyError("");
  }

  const fetchContactGroups = () => {
    const getContactGroupssURL = `${API_URL}/get_groupsByCompanyid/${logeduserData?.company_id}?page=1&limit=5000`;
    let getContactsConfig = {
      method: 'get',
      maxBodyLength: Infinity,
      url: getContactGroupssURL,
      headers: { 
        'Authorization': token
      }
    };

    axios
    .request(getContactsConfig)
    .then((response) => {
      const formattedOptions = response.data.map((group) => ({
        value: group.id,
        label: group.group_name
      }));
      setContactgroups(formattedOptions);
    })
    .catch((error) => {
      console.log(error?.response)
    });
  };
  useEffect(() => {
    fetchContactGroups();
  }, []);

  const [totalMessages, setTotalMessages] = useState(0);
  useEffect(() => {
    const messageLength = smsdata.message_body.length;
    const totalChars = 163;
    let newTotalMessages = 1;

    if (messageLength > 0) {
      newTotalMessages = Math.ceil(messageLength / totalChars);
    }

    if (newTotalMessages === 0) {
      newTotalMessages = 1;
    }

    setTotalMessages(newTotalMessages);
  }, [smsdata.message_body]);

  const calculateRemainingCharacters = () => {
    const totalCharacters = 163;
    let remainingCharacters

    if ((smsdata.message_body.length % totalCharacters) == 0 && smsdata.message_body.length !== 0) {
      remainingCharacters = 0;
    }
    else{
      remainingCharacters = totalCharacters - (smsdata.message_body.length % totalCharacters);
    }

    return { total: totalMessages, remaining: remainingCharacters };
  };

  const { total, remaining } = calculateRemainingCharacters();
  
  return (
  <div className="compose-wrapper">

    {isSubmitting && (
      <div className="loadingsubcontainer loading-overlay d-flex justify-content-center align-items-center">
        <img className="loadingsubimg" src={loading1} alt="Loading..." />
      </div>
    )}

    {/* Header */}
    <section className="content-header mb-4">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <h1><i className="fas fa-pen-alt text-primary mr-2"></i> Compose Message</h1>
          <ol className="breadcrumb bg-white p-2 rounded shadow-sm">
            <li className="breadcrumb-item"><a href="/"><i className="fas fa-home"></i> Home</a></li>
            <li className="breadcrumb-item active">Compose</li>
          </ol>
        </div>
      </div>
    </section>

    {/* Main Content */}
    <section className="content">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-primary text-white">
                <h4 className="mb-0"><i className="far fa-comment-dots mr-2"></i> Compose New Message</h4>
              </div>

              <div className="card-body">

                {/* Recipients */}
                <div className="form-group">
                  <label><i className="fas fa-users mr-2 text-secondary"></i>Select Recipient Group(s)</label>
                  <Select
                    options={contactgroups}
                    isMulti
                    placeholder="Search or select groups..."
                    value={smsdata.group_id}
                    onChange={(selectedOptions) =>
                      setsmsData({
                        ...smsdata,
                        group_id: selectedOptions
                      })
                    }
                    onFocus={removeError}
                  />
                  {groupError && <div className="alert alert-danger mt-2">{groupError}</div>}
                </div>

                {/* Subject */}
                <div className="form-group">
                  <label htmlFor="subject"><i className="fas fa-tag mr-2 text-secondary"></i>Subject</label>
                  <input
                    type="text"
                    className="form-control"
                    id="subject"
                    placeholder="E.g., Welcome to our service"
                    onChange={handleChange}
                    onFocus={removeError}
                    value={smsdata.subject}
                  />
                  {subjError && <div className="alert alert-danger mt-2">{subjError}</div>}
                </div>

                {/* Message Tags Instruction */}
                <div className="alert alert-warning">
                  <i className="fas fa-info-circle mr-2"></i>
                  Use tags like <code>&#123;first_name&#125;</code>, <code>&#123;middle_name&#125;</code>, <code>&#123;last_name&#125;</code> for personalization. Include the curly brackets.
                </div>

                {/* Message Body */}
                <div className="form-group">
                  <label htmlFor="message_body"><i className="fas fa-envelope-open-text mr-2 text-secondary"></i>Message</label>
                  <textarea
                    id="message_body"
                    className="form-control"
                    rows="5"
                    placeholder="Dear {first_name}, welcome to our platform..."
                    value={smsdata.message_body}
                    onChange={handleChange}
                    onFocus={removeError}
                  />
                  <small className="text-muted float-right mt-1">{remaining}/{total} characters</small>
                  {bodyError && <div className="alert alert-danger mt-2">{bodyError}</div>}
                </div>

              </div>

              {/* Footer Actions */}
              <div className="card-footer d-flex justify-content-between align-items-center bg-light">
                <button type="reset" className="btn btn-outline-secondary" onClick={handleDiscard}>
                  <i className="fas fa-times mr-1"></i> Discard
                </button>
                <button type="submit" className="btn btn-primary" onClick={sendSMS}>{/* This should be made in such a way that it autoloads the message lines on click save */}
                  <i className="far fa-paper-plane mr-1"></i> Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

}

export default NewMessage;
